<template>
    <div class="o-m-header-guide m-header-guide">
        <div class="m-header-guide__title">
            <button
                v-if="isExistActivePath"
                theme="dark"
                class="m-header-guide__title-back-button"
                @click="handleClickBack"
            >
                <svg-icon
                    original
                    name="icons/arrow-left"
                    class="m-header-guide__title-back-icon"
                />
                <span class="m-header-guide__title-back-text">
                    {{$t('ui.back')}}
                </span>
            </button>
            <span>
                {{ $t('o-d-guide-path-panel_header-title') }}
            </span>
            <svg-icon
                original
                name="icons/edit"
                class="m-header-guide__edit-icon"
            />
        </div>
        <div class="m-header-guide__wrapper">
            <MExtremePoint
                :label="$t('ui.start')"
                :value="startPointName"
                :inputElement="false"
                :pointIcon="false"
                @onActivate="handleFocus('start')"
                editIcon
            />
            <MExtremePoint
                :label="$t('ui.finish')"
                theme="finish"
                :value="finishPointName"
                :placeholder="$t('d-guide-search-placeholder--finish')"
                :inputElement="false"
                :pointIcon="false"
                @onActivate="handleFocus('finish')"
                editIcon
            />
            <AButton
                :text="$t('o-services-modal_start')"
                :disabled="!isActiveStartButton"
                @onClick="$emit('startGuideView', true)"
            >
                <template #right>
                    <svg-icon
                        original
                        name="icons/arrow-right-2"
                        class="a-button__arrow-right"
                    />
                </template>
            </AButton>
        </div>
        <div class="m-header-guide__controls-block">
            <AMBackButton
                theme="home"
                :text="$t('ui.home')"
                class="m-header-guide__home-button"
                @onClick="handleBackHome"
            />
            <AMBackButton
                v-if="menuRedirectUrl"
                theme="back"
                :text="$t('ui.menu')"
                class="m-header-guide__back-button"
                @onClick="handleBack"
            />
        </div>
        <ACompanyInfo
            v-if="isLandscape"
            class="m-header-guide__company-info"
        />
    <!--
            <span
            v-if="!isLandscape"
            class="m-header-guide__tip"
        >
            {{ $t('ui.directions-at') }} Mälarsjukhuset
        </span>
    -->
    </div>
</template>

<script>
import {
    mapState,
    mapGetters
} from 'vuex';

import AButton from '../../atoms/a-button/a-button';
import ACompanyInfo from '../../atoms/a-company-info/a-company-info';
import AMBackButton from '../../atoms/a-m-back-button/a-m-back-button';
import MExtremePoint from '../../molecules/m-extreme-point/m-extreme-point';

import { Storage } from '../../../utils/services/storage-service';
import { MOBILE_ROOT } from "../../../utils/constants/pages";
import { MENU_REDIRECT_URL } from "../../../utils/constants/app-constants";

export default {
    name: 'OMHeaderGuide',
    components: {
        AButton,
        ACompanyInfo,
        AMBackButton,
        MExtremePoint
    },
    props: {
        finishPoint: {
            type: Object,
            default: () => ({})
        },
        startPoint: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        ...mapState({
            isLandscape: state => state.landscape,
            activePath: state => state.activePath
        }),
        ...mapGetters([
            't'
        ]),
        startPointName() {
            return this.t(this.startPoint, 'name') || '';
        },
        finishPointName() {
            return this.t(this.finishPoint, 'name') || '';
        },
        isActiveStartButton() {
            return Boolean(this.startPoint?.id && this.finishPoint?.id);
        },
        isExistActivePath() {
            return Boolean(this.activePath?.steps);
        },
        menuRedirectUrl() {
            return Storage.local.get(MENU_REDIRECT_URL) || false;
        }
    },
    mounted() {
        this.$nextTick(() => this.alignLabelsExtremePoints());
    },
    methods: {
        handleFocus(data) {
            this.$emit('onFocusInput', true);
            this.$emit('onTypePoint', data)
        },
        alignLabelsExtremePoints() {
            const arrPointPoint = [...document.getElementsByClassName('extreme-point__point')];
            const valuesWidth = [];

            const arrExtremePoint = [...document.getElementsByClassName('m-extreme-point')];

            arrPointPoint.forEach(item => {
                valuesWidth.push(parseInt(item.offsetWidth));
            });

            arrPointPoint.forEach((item, index) => {
                item.style.width = Math.max(...valuesWidth) + 'px';
                arrExtremePoint[index].style['padding-left'] = Math.max(...valuesWidth) + 'px';
            });
        },
        handleBackHome() {
            this.$router.push({ name: MOBILE_ROOT });
        },
        handleClickBack() {
            this.$emit('returnToStart')
        },
        handleBack() {
            if (this.menuRedirectUrl) {
                this.$router.push(this.menuRedirectUrl);
            } else {
                this.$router.push({ name: MOBILE_ROOT });
            }
        }
    }
}
</script>

<style lang="scss" src="./o-m-header-guide.scss" />
